import { render, staticRenderFns } from "./MenueCard.vue?vue&type=template&id=517e77e9&scoped=true"
import script from "./MenueCard.vue?vue&type=script&lang=js"
export * from "./MenueCard.vue?vue&type=script&lang=js"
import style0 from "./MenueCard.vue?vue&type=style&index=0&id=517e77e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e77e9",
  null
  
)

export default component.exports